import {Component, ElementRef, inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Subject, takeUntil} from "rxjs";
import {LibraryCategory, LibraryItem} from "../../model/library";
import {PagePosition, PageService} from "../../services/page.service";
import {LibraryService} from "../../services/library.service";
import {StorageService} from "../../services/storage.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Router} from "@angular/router";
import {SafeHtml} from "@angular/platform-browser";
import {InformationService} from "../../services/information.service";
import {environment} from "../../../environments/environment";
import {MatSelect} from "@angular/material/select";
import {FormControl} from "@angular/forms";

@Component({
  selector: 'library',
  templateUrl: './library.component.html',
  styleUrls: ['./library.component.less'],
})
export class LibraryComponent implements OnInit, OnDestroy {

  productsCountOnPage: number = 12;

  items: LibraryItem[] = [];
  pageSize: number;
  page: number = 1;
  total: number = 0;

  libraryInfo: SafeHtml;

  content: HTMLElement | null;

  private destroySubject: Subject<void> = new Subject();
  offset: number = 0;

  showPagination: boolean = true;
  pageName: string;

  filterSet: any;
  categoryState: 'initial' | 'expanded' = 'initial';
  selectedCategory: LibraryCategory;
  libraryCategoryNames: any = environment.libraryCategoryNames

  filters: any = {};
  loading: boolean = true;

  pageService: PageService = inject(PageService);

  position: PagePosition;

  bookingItems: LibraryItem[] = []
  @ViewChild('selectCategory') selectCategory: MatSelect;

  categories: LibraryCategory[] = []

  searchString: string = '';

  findStrControl: FormControl = new FormControl<any>({});
  @ViewChild('search') search: ElementRef;

  constructor(
    private libraryService: LibraryService,
    private storageService: StorageService,
    private snackBar: MatSnackBar,
    private router: Router,
    private informationService: InformationService,
  ) {
  }

  ngOnInit(): void {

    this.informationService.getFrontParams().pipe(
      takeUntil(this.destroySubject),
    )
      .subscribe(
        (res: any) => {

          let libraryInfoHtml = res.results.find((value: any) => value.name == 'libraryInfo')?.value;
          this.libraryInfo = this.informationService.getSanitizeString(libraryInfoHtml);

        })

    this.libraryService.getCategories().pipe(
      takeUntil(this.destroySubject))
      .subscribe(event => {
          this.categories = event.results;
        }
      )

    this.items = [];
    this.pageSize = this.productsCountOnPage;
    this.content = document.getElementById('content');

    this.position = this.pageService.getPosition();
    this.filters.limit = this.productsCountOnPage;
    this.filters.offset = this.offset;

    if (this.content && this.position && this.position.pageName == this.pageName) {

      this.change(this.position.pagination);
    } else {
      this.change(1);
    }

    this.bookingItems = this.storageService.getItem('bookingItems', '[]');

    this.pageService.pageEvent.subscribe((event) => {

      if (event == 'pagination') {
        this.position.scrollPosition = 0;
      }
    })

    this.libraryService.bookingChange.pipe(
      takeUntil(this.destroySubject))
      .subscribe(event => {
        if (event?.type === 'error') {
          this.openSnackBar(event?.message);
        }
      })
  }

  changeCategory() {
    this.filters = this.selectCategory.value ? {category: this.selectCategory.value} : {}
    this.change(1)
  }
  setBaseScrollPosition() {
    let scrollElement = document.getElementById('content')
    scrollElement?.scrollTo(0, 0)

  }

  find() {
    this.change(1)
  }

  change($event: any) {

    this.items = []

    this.filters.offset = ($event - 1) * this.productsCountOnPage + this.offset;
    this.filters.search = this.findStrControl.value

    this.loading = true;

    this.libraryService.getLibraryItems(this.filters)
      .pipe(
        takeUntil(this.destroySubject),
      )
      .subscribe((res: any) => {
          this.items = res.results;

          this.total = res.count;
          this.page = $event;
          this.loading = false;
          if (this.content && this.position.pageName == this.pageName) {
          }

        }, err => {
          this.loading = false;
        }
      )
  }


  openSnackBar(message: string) {
    this.snackBar.open(message, '', {
      horizontalPosition: 'center',
      verticalPosition: 'top',
      duration: 1000,
      panelClass: 'text-center'

    });
  }

  ngOnDestroy() {
    this.destroySubject.next();
    let scrollEl = document.getElementById('content')
  }


  navigate($event: any) {
    this.router.navigate([$event], {})
  }


}




